import { IAuthor } from '../types/author';

export const AUTHORS: IAuthor[] = [
  {
    name: 'Елена Корсунская',
    url: '',
    image: '',
    jobTitle: 'Автор Циан.Журнала',
    description:
      'Родилась в Ростове-на-Дону. Окончила журфак РГУ (сейчас ЮФУ). Работала в общественно-политической газете, авиажурналах, писала в экономический еженедельник. Живёт в Петербурге с 2008 года. С 2008 года пишет про недвижимость Петербурга, Москвы, России и мира',
    gender: 'женский',
    email: 'e.korsunskaya@gmail.com',
    worksFor: 'Циан',
    sameAs: '',
    alumniOf: 'Журфак РГУ (сейчас ЮФУ)',
    knowsAbout:
      'Основные темы: новостройки, вторичная недвижимость, дизайн, интерьер, градостроительная сфера, городская среда, тренды',
    hasCredential: '',
    award: '',
  },
  {
    name: 'Эдуард Филин',
    url: '',
    image: '',
    jobTitle: 'Автор Циан.Журнала',
    description:
      'Окончил философский факультет УрГУ (ныне УрФУ). С 1992 г. занимается маркетинговыми исследованиями рынка и анализом рынка недвижимости. Автор почти сотни обзоров новостроек и новых ЖК для специализированных порталов. С 2019 г. — постоянный автор Циан.Журнала',
    gender: 'мужской',
    email: 'e.philina@gph.cian.ru',
    worksFor: 'Циан',
    sameAs: '',
    alumniOf: 'Философский факультет УрГУ (ныне УрФУ)',
    knowsAbout:
      'Ипотека, в том числе льготная, льготные программы и субсидии, анализ рынка, правовые и налоговые вопросы недвижимости',
    hasCredential: '',
    award: '',
  },
  {
    name: 'Вадим Кизимов',
    url: '',
    image: '',
    jobTitle: 'Автор Циан.Журнала',
    description:
      'Более 5 лет в инвестициях и в сфере недвижимости. Пишет для блогов ведущих изданий и платформ: Альфа-Банк, Т-Ж и Бробанк',
    gender: 'мужской',
    email: '',
    worksFor: '',
    sameAs: '',
    alumniOf: '',
    knowsAbout: 'Недвижимость, инвестиции и экономика',
    hasCredential: '',
    award: '',
  },
  {
    name: 'Татьяна Гончарова',
    url: '',
    image: '',
    jobTitle: 'Автор Циан.Журнала, автор-фрилансер',
    description: '11 лет опыта работы риелтором. 5 лет копирайтер и автор',
    gender: 'женский',
    email: '',
    worksFor: 'автор-фрилансер',
    sameAs: 'https://t.me/MytextStudio',
    alumniOf: 'Журфак РГУ (сейчас ЮФУ)',
    knowsAbout: 'Недвижимость, инвестиции в недвижимость, дизайн интерьера, психология',
    hasCredential: '',
    award: '',
  },
];
